module.exports = __webpack_public_path__ + "img/blog-13.e703840a.jpg";